import { Flex, Input, Typography } from 'antd';
import FormItem from 'components/FormItem';
import React from 'react';

const HELPER_TEXT =
  'Set Customer Tip Percentage to 100% and clear the Maximum Amount if your checkout page states that the tip is for the driver.';

const nonNegativeRule = {
  validator: (_, value) => {
    if (value === null || value === undefined || value === '') {
      return Promise.resolve();
    }
    if (Number(value) < 0) {
      return Promise.reject(new Error('Cannot be negative'));
    }
    return Promise.resolve();
  },
};

function TippingSettingsSection() {
  return (
    <>
      <Typography.Paragraph type="secondary">
        {HELPER_TEXT}
      </Typography.Paragraph>
      <Flex gap={16} wrap="wrap">
        <FormItem
          name="customer_tip_percent"
          label="Customer tip %"
          tooltip="Percentage of the customer tip to send to the driver. Default 100%."
          rules={[nonNegativeRule]}
        >
          <Input type="number" min={0} prefix="%" placeholder="100" />
        </FormItem>
        <FormItem
          name="subtotal_tip_percent"
          label="Subtotal %"
          tooltip="Percentage of food value (pre-discount subtotal) to add. Blank means 0."
          rules={[nonNegativeRule]}
        >
          <Input type="number" min={0} prefix="%" placeholder="Optional" />
        </FormItem>
        <FormItem
          name="fixed_tip_amount"
          label="Fixed amount"
          tooltip="Flat dollar amount to add to the driver tip. Blank means 0."
          rules={[nonNegativeRule]}
        >
          <Input type="number" min={0} step="0.01" prefix="$" placeholder="Optional" />
        </FormItem>
      </Flex>
      <Typography.Text strong>Driver tip limits</Typography.Text>
      <Flex gap={16} wrap="wrap">
        <FormItem
          name="driver_tip_minimum"
          label="Minimum"
          tooltip="Minimum tip sent to the driver. Blank means no minimum."
          rules={[
            nonNegativeRule,
            ({ getFieldValue }) => ({
              validator: (_, value) => {
                const maximum = getFieldValue('driver_tip_maximum');
                if (
                  value === null
                  || value === undefined
                  || value === ''
                  || maximum === null
                  || maximum === undefined
                  || maximum === ''
                ) {
                  return Promise.resolve();
                }
                if (Number(value) > Number(maximum)) {
                  return Promise.reject(new Error('Minimum cannot be greater than maximum'));
                }
                return Promise.resolve();
              },
            }),
          ]}
          dependencies={['driver_tip_maximum']}
        >
          <Input type="number" min={0} step="0.01" prefix="$" placeholder="Optional" />
        </FormItem>
        <FormItem
          name="driver_tip_maximum"
          label="Maximum"
          tooltip="Maximum tip sent to the driver. Blank means no maximum."
          rules={[
            nonNegativeRule,
            ({ getFieldValue }) => ({
              validator: (_, value) => {
                const minimum = getFieldValue('driver_tip_minimum');
                if (
                  value === null
                  || value === undefined
                  || value === ''
                  || minimum === null
                  || minimum === undefined
                  || minimum === ''
                ) {
                  return Promise.resolve();
                }
                if (Number(minimum) > Number(value)) {
                  return Promise.reject(new Error('Minimum cannot be greater than maximum'));
                }
                return Promise.resolve();
              },
            }),
          ]}
          dependencies={['driver_tip_minimum']}
        >
          <Input type="number" min={0} step="0.01" prefix="$" placeholder="Optional" />
        </FormItem>
      </Flex>
    </>
  );
}

export default TippingSettingsSection;
